/**
 * Logo da plataforma: envelope de carta branco com um selo de cera DISCRETO,
 * como os usados em correspondências antigas. O envelope é o protagonista;
 * o selo é pequeno e o brasão, carimbado em 2D com traços num tom levemente
 * mais escuro da própria cera, é um detalhe — não o fator principal.
 *
 * O brasão atual é um monograma "Z" provisório inspirado na Zion
 * (zioncheckout.com) — troque os traços dentro do selo quando a arte
 * definitiva estiver disponível.
 *
 * A cor da cera é a COR PRIMÁRIA da plataforma — hoje o AZUL do tema gamer
 * (inspirado no livepix.gg) — ver os design tokens em src/styles/global.css.
 */
export function Logo({ size = 96, title = 'Send Message' }: { size?: number; title?: string }) {
  return (
    <svg
      width={size}
      height={size * 0.75}
      viewBox="0 0 512 384"
      role="img"
      aria-label={title}
      className="logo"
    >
      {/* Envelope branco visto por trás — o protagonista do logo */}
      <rect
        x="16"
        y="24"
        width="480"
        height="336"
        rx="20"
        fill="#ffffff"
        stroke="#d6d3d1"
        strokeWidth="8"
      />
      {/* Aba superior do envelope (o "V" que desce até o centro) */}
      <path
        d="M24 40 L256 220 L488 40"
        fill="none"
        stroke="#d6d3d1"
        strokeWidth="8"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      {/* Vincos inferiores da aba de trás */}
      <path
        d="M24 344 L192 236 M488 344 L320 236"
        fill="none"
        stroke="#e7e5e4"
        strokeWidth="8"
        strokeLinecap="round"
      />

      {/* Selo de cera pequeno na ponta da aba, com leve irregularidade */}
      <g>
        <circle cx="256" cy="222" r="46" fill="var(--color-primary, #4e9bff)" />
        <circle cx="217" cy="208" r="8" fill="var(--color-primary, #4e9bff)" />
        <circle cx="295" cy="238" r="9" fill="var(--color-primary, #4e9bff)" />
        <circle cx="240" cy="264" r="7" fill="var(--color-primary, #4e9bff)" />

        {/* Impressão do carimbo: anel fino + monograma discreto */}
        <circle
          cx="256"
          cy="222"
          r="30"
          fill="none"
          stroke="var(--color-primary-stamp, #1e50a8)"
          strokeWidth="3.5"
          opacity="0.8"
        />
        {/* Monograma "Z" (placeholder do brasão da Zion) */}
        <path
          d="M241 208 H 271 L 241 236 H 271"
          fill="none"
          stroke="var(--color-primary-stamp, #1e50a8)"
          strokeWidth="7"
          strokeLinecap="square"
          strokeLinejoin="miter"
          opacity="0.8"
        />
      </g>
    </svg>
  );
}

/** Versão só do selo (para espaços pequenos, ex.: cabeçalho da dashboard). */
export function LogoSeal({ size = 32, title = 'Send Message' }: { size?: number; title?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" role="img" aria-label={title}>
      <circle cx="100" cy="100" r="80" fill="var(--color-primary, #4e9bff)" />
      <circle cx="35" cy="72" r="12" fill="var(--color-primary, #4e9bff)" />
      <circle cx="168" cy="122" r="13" fill="var(--color-primary, #4e9bff)" />
      <circle cx="72" cy="172" r="10" fill="var(--color-primary, #4e9bff)" />
      <circle
        cx="100"
        cy="100"
        r="52"
        fill="none"
        stroke="var(--color-primary-stamp, #1e50a8)"
        strokeWidth="6"
        opacity="0.8"
      />
      <path
        d="M74 76 H 126 L 74 126 H 126"
        fill="none"
        stroke="var(--color-primary-stamp, #1e50a8)"
        strokeWidth="12"
        strokeLinecap="square"
        opacity="0.8"
      />
    </svg>
  );
}
